import { render, staticRenderFns } from "./PessoaInterfaceEmailForm.vue?vue&type=template&id=52a3453d"
import script from "./PessoaInterfaceEmailForm.vue?vue&type=script&lang=js"
export * from "./PessoaInterfaceEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports